/**
 * 用户信息本地存储工具函数
 */

// 用户信息接口定义
export interface UserInfo {
  nickname?: string;
  mobile?: string;
  [key: string]: any; // 允许其他属性
}

/**
 * 获取本地存储的用户信息
 * @returns {UserInfo | null} 用户信息对象或null
 */
export function getUserInfo(): UserInfo | null {
  try {
    const userinfo = localStorage.getItem('userinfo');
    if (userinfo) {
      return JSON.parse(userinfo);
    }
    return null;
  } catch (error) {
    console.error('获取用户信息失败:', error);
    return null;
  }
}

/**
 * 设置用户信息到本地存储
 * @param {UserInfo} userinfo 用户信息对象
 */
export function setUserInfo(userinfo: UserInfo): void {
  try {
    localStorage.setItem('userinfo', JSON.stringify(userinfo));
  } catch (error) {
    console.error('设置用户信息失败:', error);
  }
}

/**
 * 清除本地存储的用户信息
 */
export function clearUserInfo(): void {
  try {
    localStorage.removeItem('userinfo');
  } catch (error) {
    console.error('清除用户信息失败:', error);
  }
}

/**
 * 检查用户是否已登录
 * @returns {boolean} 是否已登录
 */
export function isLoggedIn(): boolean {
  return getUserInfo() !== null;
}

/**
 * 获取用户昵称
 * @returns {string} 用户昵称，如果没有则返回空字符串
 */
export function getUserNickname(): string {
  const userinfo = getUserInfo();
  return userinfo?.nickname || '';
}

/**
 * 获取用户手机号
 * @returns {string} 用户手机号，如果没有则返回空字符串
 */
export function getUserMobile(): string {
  const userinfo = getUserInfo();
  return userinfo?.mobile || '';
}

/**
 * 获取用户vip状态
 * @returns {string} 用户vip，如果没有则返回默认没有vip
 */
export function isVIP(): boolean {
  const userinfo: any = getUserInfo();
  if (userinfo.member_status == 1) {
    return false;
  } else {
    return true;
  }

}

/**
 * 获取用户头像
 * @returns {string} 用户头像，如果没有则返回空字符串
 */
export function head_img(state = false): string {
  const userinfo = getUserInfo();
  if (state) {
    return userinfo?.avatar || '';
  }
  return process.env.VUE_APP_API_URL + userinfo?.avatar || '';
}

/**
 * 获取用户会员剩余天数
 * @returns {string} 用户会员，如果没有则返回0
 */
export function vip_day(): string {
  const userinfo = getUserInfo();
  return userinfo?.expire_day || '0';
}

/**
 * 获取用户会员起始天数
 * @returns {string} 用户会员，如果没有则返回空字符串
 */
export function vip_start_day(): string {
  const userinfo = getUserInfo();
  return userinfo?.member_renew_time || '';
}

//token
export function getUserToken(): string {
  const userinfo = getUserInfo();
  return userinfo?.token || '';
}

/**
 * 获取用户总练习解锁状态
 * @returns {number}
 */
export function practice_state(): string {
  const userinfo = getUserInfo();
  return userinfo?.total_practice_state || 1;
}
